import * as React from 'react';
import * as mui from '@material-ui/core';

interface Props {
    name: string;
}

interface Info {

    icon: any;
    title?: string;

}

const AVATAR_ICONS:{[k:string]: Info } = {};

export function getAppIcon(name: string) {
    if(name in AVATAR_ICONS) {
        return AVATAR_ICONS[name].icon
    }
    return null;
}

export class AppAvatar extends React.Component<Props> {

    static registerAvatarIcon(name: string, title: string, icon: any) {
        AVATAR_ICONS[name] = {
            icon: icon,
            title: title
        };
    }
    
    render() {

        const info:Info = this.props.name in AVATAR_ICONS ? AVATAR_ICONS[this.props.name] : { icon: <span>{this.props.name}</span> };

        if(info.title) {

            return (
                <mui.Tooltip title={info.title}>
                    <mui.Avatar><img src={info.icon} style={{width:"32px", height:"32px"}} alt={info.title}/></mui.Avatar>
    
                </mui.Tooltip>
    
            );
        }

        return (
            <mui.Tooltip title={this.props.name}>
                <mui.Avatar><img src={info.icon} style={{width:"32px", height:"32px"}} alt=""/></mui.Avatar>
            </mui.Tooltip>
        );

    }
}